module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "3em !important",
      "font-size": "1.7em"
    },
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/08_contents#intro"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "margin-top": "-.7em !important"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/intro-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "6em !important"
    }
  }, [_vm._v("WHEN I undertook to write this History of the 6th Queen Elizabeth’s Own Gurkha Rifles, it was in a sense in repayment of a long-standing debt I owe to a Gurkha soldier. Lance-Naik Amritbahadur of the 7th Gurkha Rifles was my orderly during the long retreat from Burma in 1942 and, on one occasion certainly, he saved my life. I have never heard of him again and undoubtedly he will have died. He was an old soldier in 1942.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In this history it will be seen how bravely and loyally the Gurkha soldier has served the British Crown for close on 200 years. Whether storming the heights of Sari Bair on Gallipoli in 1915 or charging well dug-in Japanese machine guns through the mud and blood of Mogaung in 1944 in Burma, the 6th Gurkha Rifles have at all times lived up to the Gurkha philosophy that it is ‘better to die than live a coward’. No regiment in the Brigade of Gurkhas has a finer record and I regard it as a great privilege to be asked to tell the Regiment’s story in the pages which follow.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Although I have never served in a Gurkha regiment, I have served with Gurkhas often enough, both in Burma and afterwards. In the 4th Burma Rifles, in which I served from 1939–41, our Band was entirely Gurkha and I have had many dealings with Gurkhas, both officers and riflemen, since those days. I have also visited Nepal and know the homeland of these sturdy hillmen, for whom I have always had both admiration and affection.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("One of the outstanding advantages of the Gurkha Brigade of"), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v(" the pre-1947 Indian Army was the similarity of the soldiers. Obviously there were differences between the Magars and Gurungs of Western Nepal, as recruited in the 6th, and the Limbus and Rais from the East, and more so with the higher-caste Chhetris recruited in the 9th Gurkha Rifles. Nevertheless their common characteristics and religious beliefs gave the Gurkha regiments a flexibility not otherwise to be found in the old Indian Army in which Dogras differed greatly from Pathans, as did Sikhs from Madrassis. It made it that much easier to reinforce in war one Gurkha regiment from another Gurkha regiment, regardless of the fierce pride in regiment which was such a feature of the ordinary Gurkha rifleman. What is more it seems to have applied equally to the British officers (BOs). That most famous of all 6th Gurkhas, Field Marshal Lord Slim, commanded a battalion of the 7th Gurkha Rifles, and another distinguished officer of his vintage, Bruce Scott, commanded a battalion of the 8th Gurkha Rifles. There would appear to have been a similar flexibility in the Brigade of Gurkhas since 1948 when the 2nd, 6th, 7th and 10th Gurkha Rifles were incorporated in the British Army.")])]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("There already exist three volumes of the History of the 6th Gurkha Rifles, beginning in 1817 and ending in 1982 when the Regiment was about to move from Hong Kong to Brunei, where the 6th are again serving today. In 1969 the 1st and 2nd battalions were amalgamated as a result of the reduction in strength of the Brigade of Gurkhas. Today, once again as a result of the reduction in the strength of the British Army, the Regiment faces amalgamation, this time with the 2nd King Edward VII’s Own Goorkhas (The Sirmoor Rifles), to form the 1st Battalion of The Royal Gurkha Rifles.")])]), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v("No one in either regiment can be expected to welcome such a drastic change in regimental identity but I have not the slightest doubt that the regiment which will emerge from this amalgamation will be in every way as successful and as distinguished as were its predecessors. And although there will be, inevitably, sadness at the disappearance from the "), _c('em', [_vm._v("Army List")]), _vm._v(" of two such distinguished regimental titles, some consolation can be found from the fact that there will still be Gurkhas serving the British")]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_vm._v(" Crown, as they have done so gallantly in the past. How gallantly will be clear from this story of the 6th Gurkhas which follows.")])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Regimental history can hardly be regarded as popular reading, apart from those who have a vested interest in the particular story or for military historians engaged in research. The Gurkhas, however, have long had a special place in the affections of the British people and with this in mind I have tried to avoid too detailed descriptions of events and individuals, but rather to convey the "), _c('em', [_vm._v("esprit")]), _vm._v(" which made the 6th Gurkhas the fine regiment that it was, and to give some impression of the "), _c('em', [_vm._v("panache")]), _vm._v(" and "), _c('em', [_vm._v("élan")]), _vm._v(" of the ordinary Gurkha rifleman which has made service with him so worthwhile – and such fun!")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_c('em', [_vm._v("James Lunt")]), _c('br'), _c('em', [_vm._v("Oxford 1994")]), _vm._v(".")])])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c3f05a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/13_introduction.vue
// module id = 90
// module chunks = 0